import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';
import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useQuery } from '@apollo/client';
import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { PRACTICE_TEST_STATUS, USER_STATUS } from '../browse-tests/constants';
import { GET_PRACTICE_TEST_BY_USER } from '../../../core/graphql/test-sessions';
import withGa from '../../../core/components/with-ga';
import withLayout from '../../../core/components/with-layout';
import tabs from '../../constants/tabs';
import { Centered } from '../browse-tests/styles';
import { profileRequiredFields } from './constants';

const TesterRoot = (props) => {
  const {
    user,
    profile: profileProp,
  } = props;

  const { id: userId = '', status, profile: userProfile = {} } = user || {};

  const profile = profileProp || userProfile;

  const {
    data: { userPracticeTest = {} } = {},
    loading: practiceTestLoading,
  } = useQuery(GET_PRACTICE_TEST_BY_USER, {
    variables: { userId },
    skip: !userId,
  });

  const hasPracticeTest = userPracticeTest && !_.isEmpty(userPracticeTest);
  const practiceTestApproved = hasPracticeTest && userPracticeTest.practiceTestStatus === PRACTICE_TEST_STATUS.APPROVED;
  const practiceTestNotSubmitted = hasPracticeTest && userPracticeTest.practiceTestStatus === PRACTICE_TEST_STATUS.NOT_SUBMITTED;
  const practiceTestRejected = hasPracticeTest && userPracticeTest.practiceTestStatus === PRACTICE_TEST_STATUS.REJECTED;
  const practiceTestBlocked = hasPracticeTest && userPracticeTest.practiceTestStatus === PRACTICE_TEST_STATUS.BLOCKED;

  const isCompletedProfile = useMemo(() => {
    let isComplete = !_.isNull(profile);

    if (isComplete) {
      _.forEach(profileRequiredFields, (field) => {
        switch (field) {
          case 'state':
            if (profile.country === 'us') {
              isComplete = !!profile[field];
            }
            break;
          default:
            isComplete = !!profile[field];
        }
      });
    }

    return isComplete;
  }, [profile]);

  const profileIsComplete = !_.isEmpty(user) && isCompletedProfile;

  const redirectPath = useMemo(() => {
    let finalRedirectPath = '';

    if (status === USER_STATUS.APPROVED && practiceTestApproved && !profileIsComplete) {
      finalRedirectPath = '/profile';
    } else if ((!hasPracticeTest && status === USER_STATUS.PENDING)
      || (practiceTestNotSubmitted && status !== USER_STATUS.APPROVED)) {
      finalRedirectPath = '/video-instruction';
    } else if (practiceTestBlocked) {
      finalRedirectPath = '/blocked';
    } else if (practiceTestRejected) {
      finalRedirectPath = '/rejected';
    } else {
      finalRedirectPath = '/browse-tests';
    }
    return finalRedirectPath;
  }, [
    status,
    practiceTestApproved,
    profileIsComplete,
    hasPracticeTest,
    practiceTestNotSubmitted,
    practiceTestBlocked,
    practiceTestRejected,
  ]);

  const history = useHistory();
  // ...

  useEffect(() => {
    history.push(redirectPath);
  }, [redirectPath, history]);

  if (practiceTestLoading) {
    return (
      <Container>
        <Centered>
          <Loader data-loader="tester-loader" />
        </Centered>
      </Container>

    );
  }

  return (
    null
  );
};

TesterRoot.propTypes = {
  // history: PropTypes.object.isRequired,
  user: PropTypes.shape(
    {
      id: PropTypes.string,
      admin: PropTypes.bool,
      guest: PropTypes.bool,
      tester: PropTypes.bool,
      status: PropTypes.string,
      profile: PropTypes.shape(
        // TODO:
        /* todo: some dispatchs are made out of order in the redux post sign in actions. We need to refactor, so that we have
        / profile and users at the same time */
        {
          annualHouseholdIncome: PropTypes.string,
          birthdate: PropTypes.string,
          computer: PropTypes.string,
          country: PropTypes.string,
          currentPosition: PropTypes.string,
          educationLevel: PropTypes.string,
          email: PropTypes.string,
          firstName: PropTypes.string,
          gender: PropTypes.string,
          id: PropTypes.string,
          jobCategories: PropTypes.string,
          languages: PropTypes.string,
          lastName: PropTypes.string,
          paypalAccount: PropTypes.string,
          raceEthnicHeritage: PropTypes.string,
          smartphone: PropTypes.string,
          state: PropTypes.string,
          tablet: PropTypes.string,
          workStatus: PropTypes.string,
        },
      ),
    },
  ).isRequired,
  profile: PropTypes.shape({
    annualHouseholdIncome: PropTypes.string,
    birthdate: PropTypes.string,
    computer: PropTypes.string,
    country: PropTypes.string,
    currentPosition: PropTypes.string,
    educationLevel: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    gender: PropTypes.string,
    id: PropTypes.string,
    jobCategories: PropTypes.string,
    languages: PropTypes.string,
    lastName: PropTypes.string,
    paypalAccount: PropTypes.string,
    raceEthnicHeritage: PropTypes.string,
    smartphone: PropTypes.string,
    state: PropTypes.string,
    tablet: PropTypes.string,
    workStatus: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = ({ authentication, notification }) => ({
  user: authentication.user,
  profile: authentication.profile,
  status: authentication.status,
  alert: notification,
});

export default compose(
  withLayout({ selectedTab: tabs.BROWSE_TESTS }),
  connect(mapStateToProps, null),
  withGa,
)(TesterRoot);
